module.exports = __webpack_public_path__ + "img/documento-selfie.f265ae42.png";